import Vue from "vue";
import ExposeMap from "../components/map/ExposeMap.vue";

export default () => {
  const elements = document.querySelectorAll(".vue-expose-map");

  if (elements) {
    elements.forEach((el) => {
      let entry = ExposeMap;

      new Vue({
        el,

        computed: {
          mapZoom() {
            let zoom = 10;
            if (el.dataset.zoom) {
              zoom = el.dataset.zoom;
            }

            return zoom;
          },

          mapCenter() {
            let center = {
              lat: 48.219139,
              lng: 7.778690
            };
            if (el.dataset.center) {
              center = JSON.parse(el.dataset.center);
            }

            return center;
          }
        },

        render: h => h(entry)
      })
    });
  }
};
